import axios from 'axios'
import store from '../store'

export const refreshPageMixin = {
  data () {
    return {
      currentHash: '{{POST_BUILD_ENTERS_HASH_HERE}}',
      token: localStorage.getItem('user-token'),
      hashChanged: false,
      newHash: ''
    }
  },
  methods: {
    initVersionCheck (url) {
      this.checkVersion(url)
    },
    async checkVersion (url) {
      try {
        let uri = `${store.state.config.baseUrl}/${url}`
        const fileResponse = await axios.create({
          headers: {
            'Authorization': 'JWT ' + this.token,
            'Content-type': 'application/json'
          }
        }).get(uri + '?t=' + new Date().getTime())
        this.newHash = fileResponse.data.hash
        if (this.currentHash !== this.newHash) {
          console.info('reload app due to out of date version of StREAM')
          this.currentHash = this.newHash
          window.location.reload(true)
        }
      } catch (error) {
        this.loading = false
        if (!error.response) {
          this.errorStatus = 'Error: Network Error'
        } else {
          this.errorStatus = error.response.data.message
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/refresh-page.mixin.js